<template>
	<div class="con">
		<div class="head">
			<div>处方药品列表</div>
			<div class="head-price"><span>￥</span>{{total}}</div>
		</div>
		
		<div class="content">
			
			<div class="list-con" v-for="(item, index) in list" @click="indexBtn(index)">
				<div>
					<div class="list-con-top">
						<div class="list-text-left">
							<div class="classify">{{item.SFMC}}</div>
						</div>
						<div class="list-text-right">
							<div class="price">
								<div><span>￥</span>{{item.totalprice}}</div>
							</div>
							<div v-show="item.showState"><van-icon name="arrow-down" color="#999" size="18"/></div>
							<div v-show="!item.showState"><van-icon name="arrow" color="#999" size="18"/></div>
						</div>
					</div>
				</div>
				<div class="hide-show" v-show="item.showState">
					<div v-for="cell in item.d" class="list-hide-show">
						<div class="hide-show-left">{{cell.FYMC}}</div>
						<div class="hide-show-right">
							<div class="hide-show-price"><span>￥</span>{{cell.ZJJE}}</div>
							<div class="hide-show-num">x{{cell.XMSL}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无清单列表~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'prescription',
		data () {
		    return {
		      msg: '处方笺',
			  list: [],
			  noImgShow: false,
			  total: 0,
		    }
		},
		methods:{
			//挂号处方详情查询
			registerRecipe(e){
				this.$store.commit('Load',true)
				this.$Axios.Get('/outpatient/registerRecipe?sbxh='+ e, null).then(res => {
					this.$store.commit('Load',false)
					console.log(res)
					
					if(res.code == 0) {
						if(res.msg.length != 0) {
							var listData = res.msg;
							let newArr = JSON.parse(JSON.stringify(listData))
							
							for (let i = 0; i < newArr.length; i++) {
								newArr[i].showState = false;
								
								for (let j = i + 1; j < newArr.length;) {
							
									if (newArr[i].SFMC == newArr[j].SFMC) {
										newArr.splice(j, 1)
									} else {
										j++;
									}
								}
							}
							let total = 0;
							for (let j = 0; j < listData.length; j++) {
								total += listData[j].ZJJE;
							}
							
							for (let i = 0; i < newArr.length; i++) {
								let s = [];
								let dn = 0;//数量
								let dprice = 0;
								
								for (let j = 0; j < listData.length; j++) {
									
									if(newArr[i].SFMC == listData[j].SFMC){
										s.push(listData[j]);
										dn += listData[j].XMSL;
										dprice += listData[j].ZJJE;
									}
								}
								newArr[i].num = dn;
								newArr[i].totalprice = dprice.toFixed(2);
								newArr[i].d = s;
								
							}
							this.total = total.toFixed(2)
							console.log(newArr)
							this.list = newArr;
							
							
							this.noImgShow = false;
							// this.list = res.msg;
						} else {
							this.noImgShow = true;
							this.list = []
						}
					
					} else {
						this.noImgShow = true;
						this.list = []
					}
				}).catch(err => {
					this.$store.commit('Load',false)
					console.log(err)
				})
			},
			indexBtn(e){
				this.list[e].showState = !this.list[e].showState
				this.$set(this.list, e, this.list[e])
			},
		},
		mounted(){
			var u = JSON.parse(this.$route.query.user)
			// this.user = JSON.parse(this.$route.query.user);
			this.registerRecipe(u.SBXH);
		},
		
	}
</script>

<style scoped>
	.head {
		display: flex;
		justify-content: space-between;
		padding: 20px 10px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}
	.head-price{
		color: #FF0000;
		font-size: 20px;
		font-weight: 700;
	}
	.head-price span{
		font-size: 14px;
		font-weight: 500;
	}
	.list-title{
		display: flex;
		justify-content: space-between;
		padding: 10px 15px;
		font-size: 17px;
		font-weight: 700;
		background: #fff;
	}
	.list-con{
		padding: 10px;
		margin: 5px auto;
		font-size: 15px;
		border: 1px solid #ccc;
		border-radius: 10px;
		width: 90%;
		background-color: #fff;
	}
	.classify{
		font-size: 18px;
		font-weight: 700;
	}
	.list-con-top{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.list-text-left{
		width: 50%;
		 white-space: normal;
		    display: -webkit-box;
		    -webkit-box-orient: vertical;
		    -webkit-line-clamp: 2;	/*控制文字行数*/
	}
	.list-text-right{
		display: flex;
		align-items: center;
	}
	.list-total-num{
		font-size: 16px;
		text-align: end;
	}
	.time-disp{
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}
	.time-text{
		margin-left: 10px;
	}
	.price{
		display: flex;
		align-items: center;
		color:#FF0000;
		font-size: 18px;
	}
	.price span{
		font-size: 12px;
	}
	.hide-show{
		margin-top: 10px;
		
	}
	.list-hide-show{
		margin: 5px;
		display: flex;
		justify-content: space-between;
	}
	.hide-show-left{
		width: 75%;
	}
	.hide-show-price{
		color: #FF0000;
	}
	.hide-show-num{
		text-align: end;
	}
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
</style>


